import { useEffect } from 'react';
import { setDocumentMeta } from './metaTags';

/**
 * Set `document.title` for the lifetime of the calling component. Wraps the
 * existing `setDocumentMeta` helper so static pages don't have to reach into
 * a useEffect every time they want to title themselves.
 *
 * Mirrors the existing pattern used by JobDetailPage:
 * each route mounts and overwrites the title — there's no restore-on-unmount
 * because the next route is expected to set its own. As long as every public
 * route titles itself, the index.html fallback only ever surfaces on a hard
 * refresh into a route that opted out (which we don't have today).
 *
 * Pass a stable string. The effect re-fires if the string changes — useful
 * for dynamic titles (e.g., "<Job title> — QuantumHire") but not strictly
 * required for static ones.
 */
export function usePageTitle(title: string): void {
  useEffect(() => {
    setDocumentMeta({ title });
  }, [title]);
}
